export const ar = {
  // Common
  loading: "جاري التحميل...",
  save: "حفظ",
  cancel: "إلغاء",
  delete: "حذف",
  edit: "تعديل",
  search: "بحث",
  filter: "تصفية",
  confirm: "تأكيد",
  error: "خطأ",
  success: "نجح",
  filters: "الفلاتر",
  previous: "السابق",
  next: "التالي",
  page: "الصفحة",
  pageInfo: "الصفحة {{current}} من {{total}}",
  back: "رجوع",
  activate: "تفعيل",
  contactPerson: "جهة الاتصال",
  postalCode: "الرمز البريدي",
  additionalNumber: "الرقم الإضافي",
  kingdomOfSaudiArabia: "المملكة العربية السعودية",
  signOut: "تسجيل الخروج",

  // Not Found Page
  notFound: {
    title: "الصفحة غير موجودة",
    description: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  },

  // Shared - Table translations
  shared: {
    signIn: "تسجيل الدخول",
    table: {
      id: "الرقم التعريفي",
      tenantName: "اسم المستأجر",
      type: "النوع",
      city: "المدينة",
      numberOfBranches: "عدد الفروع",
      status: "الحالة",
      discountPercent: "نسبة الخصم %",
      contactName: "اسم جهة الاتصال",
      contactDetails: "تفاصيل الاتصال",
      dateCreated: "تاريخ الإنشاء",
      actions: "الإجراءات",
      hospital: "مستشفى",
      clinic: "عيادة",
      other: "أخرى",
      active: "نشط",
      pending: "قيد الانتظار",
      previous: "السابق",
      next: "التالي",
      page: "الصفحة",
      of: "من",
      product: "المنتج",
      category: "الفئة",
      brand: "العلامة التجارية",
      productStatus: "حالة المنتج",
      inactive: "غير نشط",
      variationGroup: "مجموعة التباين",
      price: "السعر",
      published: "منشور",
      draft: "مسودة",
      edit: "تعديل",
      copy: "نسخ",
    },
    entityType: {
      POLY_CLINIC: "عيادة متعددة",
      HOSPITAL: "مستشفى",
      OTHER: "أخرى",
    },
    tenantActivation: {
      activateNow: "تفعيل الآن",
      activateNowDescription: "يمكنك تفعيل هذا المستأجر الآن أو إكمال الإعداد لاحقاً.",
      activateNowLabel: "تفعيل الآن",
      notNowLabel: "ليس الآن",
      successTitle: "تم التفعيل بنجاح",
      successDescription: "تم تفعيل المستأجر بنجاح ويمكنه الآن الوصول إلى النظام.",
      confirm: "تأكيد",
      // Modal title and subtitle
      modalTitle: "تفعيل المستأجر",
      modalSubtitle: "راجع التفاصيل وأكمل الإعداد قبل منح الوصول.",
      // Stepper steps
      stepReviewInfo: "مراجعة المعلومات",
      stepAssignBranch: "تعيين الفرع",
      stepConfirmActivate: "تأكيد",
      // Button labels
      cancel: "إلغاء",
      next: "التالي",
    },
    // Sidebar translations
    sidebar: {
      dashboard: "لوحة التحكم",
      tenants: "المستأجرين",
      users: "المستخدمين",
      catalog: "الكتالوج",
      catalogAssignment: "تعيين الكتالوج",
      purchase: "أوامر الشراء",
      purchaseRequests: "طلبات الشراء",
      branches: "الفروع",
    },
    tableToolbar: {
      viewAll: "عرض الكل",
      active: "نشط",
      pending: "قيد الانتظار",
      searchPlaceholder: "بحث",
      filters: "فلاتر",
    },

    // Form validation and field labels
    branchForm: {
      // Form field labels
      branchName: "اسم الفرع",
      city: "المدينة",
      district: "الحي",
      address: "العنوان",
      contactFirstName: "الاسم الأول لجهة الاتصال",
      contactLastName: "اسم العائلة لجهة الاتصال",
      contactEmail: "البريد الإلكتروني لجهة الاتصال",
      contactPhone: "رقم الهاتف لجهة الاتصال",

      // Placeholders
      branchNamePlaceholder: "أدخل اسم الفرع",
      cityPlaceholder: "اختر المدينة",
      districtPlaceholder: "أدخل اسم الحي",
      addressPlaceholder: "أدخل العنوان",
      firstNamePlaceholder: "أدخل الاسم الأول",
      lastNamePlaceholder: "أدخل اسم العائلة",
      emailPlaceholder: "أدخل البريد الإلكتروني للمستخدم",
      phonePlaceholder: "أدخل بدون رمز الدولة",

      // Validation messages
      required: "مطلوب",
      invalidEmail: "عنوان البريد الإلكتروني غير صحيح",
      maxLength: "لا يمكن أن يتجاوز 50 حرفاً",
      minLength: "يجب أن يكون 3 أحرف على الأقل",
      invalidPhone: "رقم الهاتف غير صحيح",
      invalidAddress: "يُسمح فقط بالأحرف",
      invalidBranchName: "يُسمح فقط بالأحرف",

      // Country names
      countries: {
        SA: "المملكة العربية السعودية",
        EG: "مصر",
        AE: "الإمارات العربية المتحدة",
      },
      filters: {
        priceRange: "نطاق السعر",
      },
    },

    // Add WrongPortal translations
    wrongPortal: {
      title: "تم رفض الوصول",
      description: "ليس لديك الصلاحيات المناسبة للوصول إلى هذا البوابة.",
      contactAdmin: "يرجى الاتصال بالمدير أو محاولة تسجيل الدخول إلى البوابة الصحيحة.",
      tryAgain: "حاول مرة أخرى",
      goToHub: "اذهب إلى سورجيا هب",
      goToAdmin: "اذهب إلى سورجيا أدمن",
      accessDeniedToast: "تم رفض الوصول",
      accessDeniedDescription: "حاول تسجيل الدخول إلى البوابة الصحيحة.",
    },
  },

  //hub
  hub: {
    // Common form fields
    formFields: {
      clinicHospitalName: "اسم العيادة/المستشفى",
      clinicHospitalType: "نوع العيادة/المستشفى",
      country: "البلد",
      city: "المدينة",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "البريد الإلكتروني لجهة الاتصال",
      mobile: "رقم الجوال لجهة الاتصال"
    },
    placeholders: {
      clinicHospitalName: "أدخل اسم العيادة/المستشفى",
      clinicHospitalType: "اختر النوع",
      country: "اختر البلد",
      city: "اختر المدينة",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "أدخل البريد الإلكتروني للاتصال",
      mobile: "أدخل بدون رمز الدولة",
      loadingCities: "جاري تحميل المدن..."
    },
    // Register page specific
    register: {
      pageTitle: "تسجيل عملك",
      pageSubtitle: "يرجى ملء معلوماتك لطلب الحساب",
      contactEmail: "info@surgia.co",
      submit: "إرسال",
      submitting: "جاري الإرسال...",
      existingAccount: "لديك حساب بالفعل؟",
      signIn: "تسجيل الدخول",
      mobile: "أدخل رقم الهاتف",      // Error messages
      nameExists: "اسم العيادة/المستشفى موجود بالفعل",
      emailExists: "هذا البريد الإلكتروني موجود بالفعل",
      mobileExists: "رقم الجوال موجود بالفعل",
      offlineError: "أنت غير متصل بالإنترنت. يرجى التحقق من اتصالك بالإنترنت.",
      successMessage: "تم إرسال الطلب بنجاح"
    },
    verifyInvitation: {
      invitationVerified: "تم التحقق من الدعوة!",
      invitationError: "خطأ في الدعوة",
      verifying: "جاري التحقق من دعوتك...",
      successTitle: "نجح!",
      successMessage: "تم التحقق من دعوتك. سيتم إعادة التوجيه إلى صفحة تسجيل الدخول خلال {{count}} ثانية{{plural}}...",
      signInNow: "تسجيل الدخول الآن",
      verificationFailed: "فشل التحقق",
      verificationFailedMessage: "رمز الدعوة غير صحيح أو منتهي الصلاحية. يرجى طلب دعوة جديدة.",
      returnHome: "العودة للرئيسية",
      invitationValidationFailed: "فشل التحقق من صحة الدعوة"
    }
  },

  //admin
  admin: {
    // Navigation
    dashboard: "لوحة التحكم",
    tenants: "المستأجرين",
    tenantsSubtitle: "إدارة ومراقبة جميع الحسابات المؤسسية",
    createNew: "إنشاء جديد",
    products: "المنتجات",

    // Admin-specific content
    welcome: "مرحباً بك في بوابة إدارة سورجيا",
    manageTenants: "إدارة المستأجرين",
    addBranch: "إضافة فرع",

    // Roles specific to healthcare
    admin: "مدير",
    procurement: "مدير المشتريات",
    clinical: "المشغل السريري",

    // Table Actions and States
    activate: "تفعيل",

    // Filters Modal
    idRange: "نطاق المعرف (مثال 1333-1350)",
    selectCity: "اختر المدينة",
    selectType: "اختر النوع",
    selectStatus: "اختر الحالة",
    discount: "الخصم",
    discountPercentage: "نسبة الخصم",
    selectDateOrRange: "اختر تاريخ أو نطاق",
    clearFilters: "مسح الفلاتر",

    // Users Tab Section
    generalInfo: "المعلومات العامة",
    branches: "الفروع",
    catalog: "الكتالوج",
    complianceDocuments: "وثائق الامتثال",
    purchaseOrders: "أوامر الشراء",
    allBranches: "جميع الفروع",
    addUser: "إضافة مستخدم",
    toasters: {
      tenantActicated: "تم تفعيل المستأجر بنجاح!",
      tenantActivationFailed: "فشل في تفعيل المستأجر",
      tryAgain: "يرجى المحاولة مرة أخرى لاحقاً.",
      branchCreated: "تم إنشاء الفرع بنجاح!",
      branchCreationFailed: "فشل في إنشاء الفرع"
    },

    // Product Assignment Page
    productAssignment: {
      pageTitle: "تعيين المنتج",
      pageSubtitle: "إعداد وتكوين المنتجات لكتالوجك",
      tenantName: "مستشفى الملك فيصل التخصصي",
      breadcrumb: {
        tenants: "المستأجرين",
        tenantDetails: "تفاصيل المستأجر",
        assignProduct: "تعيين المنتج"
      },
      actions: {
        cancel: "إلغاء",
        saveAsDraft: "حفظ كمسودة",
        previous: "← السابق",
        next: "التالي →",
        finish: "إنهاء"
      },
      steps: {
        selectProducts: {
          title: "اختيار المنتجات",
          subtitle: "من المنتجات المشتركة",
          loadingProducts: "جاري تحميل المنتجات..."
        },
        configureDetails: {
          title: "تكوين التفاصيل",
          subtitle: "تعيين المتغيرات وتخصيص أسماء المنتجات."
        },
        customerView: {
          title: "عرض العميل",
          subtitle: "التحكم في عرض كتالوج العميل"
        }
      },
      content: {
        selectProducts: {
          title: "اختيار المنتجات",
          commonProducts: "المنتجات المشتركة",
          searchPlaceholder: "البحث بالاسم أو المعرف",
          filters: "الفلاتر",
          productsSelected: "المنتجات المختارة",
          configureDetails: "محتوى لتكوين تفاصيل المنتجات والمتغيرات.",
          customerView: "محتوى للتحكم في عرض كتالوج العميل."
        }
      },
      messages: {
        productsAssignedSuccess: "تم تعيين المنتجات بنجاح!",
        productsAssignedError: "فشل في تعيين المنتجات",
        tryAgain: "يرجى المحاولة مرة أخرى",
        selectAtLeastOne: "يرجى اختيار منتج واحد على الأقل",
        assigning: "جاري التعيين...",
        loadingProducts: "جاري تحميل المنتجات...",
        noProductsFound: "لم يتم العثور على منتجات",
        noProductsSelected: "لم يتم اختيار منتجات",
        // Add these new messages
        saveProgressGoBack: "حفظ التقدم والعودة",
        saveProgressSubtitle: "سيتم حفظ اختيارات المنتجات الحالية كمسودة قبل العودة.",
        stayHere: "البقاء هنا",
        saveAndGoBack: "حفظ والعودة",
        goingBackMessage: "العودة ستسمح لك باختيار منتجات مختلفة مع الحفاظ على اختياراتك الحالية كمسودة للاستخدام لاحقاً.",
        failedToUpdateVisibility: "فشل في تحديث الرؤية. يرجى المحاولة مرة أخرى.",
        loadingProductsMessage: "جاري تحميل المنتجات...",
        // Add these new messages for the footer section
        productsSelected: "المنتجات المختارة",
        previous: "← السابق",
        finish: "إنهاء"
      },
      filters: {
        priceFilterError: "يجب أن يحتوي فلتر السعر على قيمتين كحد أدنى وأقصى",
        selectCategory: "اختر فئة",
        selectBrand: "اختر علامة تجارية",
        priceRange: "نطاق السعر",
        category: "الفئة",
        brand: "العلامة التجارية",
      },
      specifyVariantsTitle: "تحديد المتغيرات",
      loadingProducts: "جاري تحميل المنتجات...",
      changesDiscarded: "تم تجاهل التغييرات",
    },

    // Tenant Details Page
    tenantDetails: {
      pageTitle: "تفاصيل المستأجر",
      breadcrumb: {
        tenants: "المستأجرين",
        tenantDetails: "تفاصيل المستأجر"
      },
      actions: {
        addBranch: "إضافة فرع"
      },
      tabs: {
        generalInfo: "المعلومات العامة",
        branches: "الفروع",
        users: "المستخدمين",
        catalog: "الكتالوج",
        complianceDocuments: "وثائق الامتثال",
        purchaseRequests: "طلبات الشراء",
        purchaseOrders: "أوامر الشراء"
      },
      content: {
        generalInfo: {
          title: "المعلومات العامة",
          description: "معلومات وتفاصيل المستأجر العامة"
        },
        branches: {
          title: "الفروع",
          description: "إدارة فروع ومواقع المستأجر"
        },
        users: {
          title: "المستخدمين",
          description: "إدارة مستخدمي المستأجر والصلاحيات"
        },
        catalog: {
          title: "الكتالوج",
          description: "إدارة كتالوج منتجات المستأجر"
        },
        complianceDocuments: {
          title: "وثائق الامتثال",
          description: "إدارة وثائق الامتثال والتنظيم"
        },
        purchaseRequests: {
          title: "طلبات الشراء",
          description: "عرض وإدارة طلبات الشراء"
        },
        purchaseOrders: {
          title: "أوامر الشراء",
          description: "عرض وإدارة أوامر الشراء"
        }
      },
      messages: {
        tenantActivated: "تم تفعيل المستأجر بنجاح!",
        tenantActivationFailed: "فشل في تفعيل المستأجر",
        tryAgain: "يرجى المحاولة مرة أخرى لاحقاً.",
        activateNow: "تفعيل الآن",
        activateNowDescription: "يمكنك تفعيل هذا المستأجر الآن أو إكمال الإعداد لاحقاً.",
        activateNowLabel: "تفعيل الآن",
        notNowLabel: "ليس الآن",
        successTitle: "تم التفعيل بنجاح",
        successDescription: "تم تفعيل المستأجر بنجاح ويمكنه الآن الوصول إلى النظام.",
        confirm: "تأكيد",
        modalTitle: "تفعيل المستأجر",
        modalSubtitle: "راجع التفاصيل وأكمل الإعداد قبل منح الوصول.",
        stepReviewInfo: "مراجعة المعلومات",
        stepAssignBranch: "تعيين الفرع",
        stepConfirmActivate: "تأكيد",
        cancel: "إلغاء",
        next: "التالي"
      }
    },

  },

  // Validation
  required: "هذا الحقل مطلوب",
  invalid_email: "تنسيق البريد الإلكتروني غير صحيح",
  password_too_short: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  passwords_dont_match: "كلمات المرور غير متطابقة",

  // Product Card Component
  productCard: {
    variant: "متغير",
    variants: "متغيرات",
    customerProductName: "اسم منتج العميل",
    customerProductNamePlaceholder: "اسم منتج العميل",
    customerProductNameHelp: "سيظهر هذا الاسم في كتالوج العميل.",
    productVariants: "متغيرات المنتج",
    cancel: "إلغاء",
    save: "حفظ",
    expand: "توسيع",
    collapse: "طي",
    selection: "اختيار",
    variantSelection: "اختيار المتغير",
    product: "المنتج"
  }
} 